import { urls } from 'Utilities/dataHelpers';
import * as log from 'Utilities/log';
import mediator from 'Utilities/mediator';
export const updateConsent = (patientId, action, app, dataId, accessToken) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'PUT',
            url: urls.libreSharingApiCountryUrl + 'v1/patients/' + patientId + '/consents',
            headers: {
                'X-User-Agent': app,
                Authorization: `Bearer ${accessToken}`,
            },
            data: {
                id: dataId,
                action,
            },
        })
            .then((result) => {
            if (result.data) {
                return resolve(result.data);
            }
            reject();
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
